// /////////////////////////////////////////////////////////////////////////////////////
//                              Copyright (c) 2026
//                                    RXO Inc.
//                          All Rights Reserved Worldwide
//
// WARNING:  This program (or document) is unpublished, proprietary
// property of RXO Inc. and is to be maintained in strict confidence.
// Unauthorized reproduction, distribution or disclosure of this program
// (or document), or any program (or document) derived from it is
// prohibited by State and Federal law, and by local law outside of the U.S.
// /////////////////////////////////////////////////////////////////////////////////////

import { isSelfPricedTruckload } from "./isSelfPricedTruckload";
import { mode, status as bidStatus, userRole } from "./types";

export { isSelfPricedTruckload };

/**
 * Self-priced TL sales-rep path may show early Close Bid when the feature flag is on.
 * Callers still gate on bid status (pending, in progress, submitted).
 */
export function shouldShowSelfPricedEarlyCloseBid(summary, user, selfPricedCloseLostFlag) {
  if (!selfPricedCloseLostFlag || !summary?.modes || !user) {
    return false;
  }
  const role =
    user.role === userRole.management
      ? user.userRoleForManagementUser
      : user.role;
  if (role !== userRole.salesRep) {
    return false;
  }
  return isSelfPricedTruckload(summary);
}

export function shouldShowRejectedCloseBid(summary, user, selfPricedCloseLostFlag) {
  if (!selfPricedCloseLostFlag || !summary?.modes || !user) {
    return false;
  }
  const role =
    user.role === userRole.management
      ? user.userRoleForManagementUser
      : user.role;
  if (role !== userRole.salesRep) {
    return false;
  }
  return summary.modes.some(
    m => m.mode === mode.tl && m.status === bidStatus.rejected
  );
}